import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import CardActivatePage from './pages/CardActivatePage';
import AuthPage from './pages/AuthPage';
import { SuccessPage } from './pages/SuccessPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { OnlyHome } from './hoc/OnlyHome';
import MaintenancePage from './pages/MaintenancePage';
import { getMaintenanceStatus } from './config/maintenance';

function App() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const status = await getMaintenanceStatus();
        setIsMaintenanceMode(status.is_maintenance_mode);
      } catch (error) {
        console.error('Error checking maintenance status:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkMaintenance();
  }, []);

  if (isLoading) {
    return null; // или показать загрузку
  }

  // If in maintenance mode, show maintenance page
  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Header />}>
          <Route path="/" element={<CardActivatePage />} />
          <Route
            path="add"
            element={
              <OnlyHome>
                <AuthPage />
              </OnlyHome>
            }
          />
          <Route
            path="success"
            element={
              <OnlyHome>
                <SuccessPage />
              </OnlyHome>
            }
          />
          <Route
            path="*"
            element={
              <OnlyHome>
                <NotFoundPage />
              </OnlyHome>
            }
          />
        </Route>
      </Routes>
    </>
  );
}

export default App;